<button mat-icon-button (click)="close()">
  <mat-icon svgIcon="nav/close-black"></mat-icon>
</button>
<app-reservation [reservation]="reservation" [expanded]="true"></app-reservation>
<div class="actions">
  <button mat-fab (click)="markSkipped()" *ngIf="!reservation.state" class="move-fab skipped">
    <mat-icon svgIcon="material-states/skipped-blue"></mat-icon>
  </button>
  <button mat-fab (click)="markNotFound()" *ngIf="!reservation.state" class="move-fab not-found">
    <mat-icon svgIcon="material-states/not-found-blue"></mat-icon>
  </button>
  <button mat-fab (click)="markFound()" *ngIf="!reservation.state" class="move-fab primary found">
    <mat-icon svgIcon="material-states/found"></mat-icon>
  </button>
  <button mat-fab (click)="undo()" *ngIf="reservation.state && reservation.canUndo" class="move-fab undo">
    <mat-icon svgIcon="material-states/undo-blue"></mat-icon>
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/pick-up-list/reservation-dialog/reservation-dialog.component.html